/**
 * Workspace Persistence Adapter – Phase 3C.
 *
 * Routes layout mutation saves into the workspace draft persistence layer.
 *
 * Rules:
 *  - runtimeMode === 'draft-edit': schedule a debounced draft save via API
 *  - runtimeMode === 'runtime':    block silently (operators cannot mutate)
 *  - Published workspace versions are NEVER touched here
 *
 * The draft is created automatically on first save if none exists
 * (copy-on-write semantics handled by the backend update_draft service).
 */
import { scheduleDraftSave } from '../../workspaceRuntime/workspaceDraftService';
import { RUNTIME_MODE } from '../../workspaceRuntime/workspaceResolverService';

/**
 * @typedef {import('../../workspaceRuntime/workspaceResolverService').RuntimeContext} RuntimeContext
 */

/**
 * Save a layout snapshot for a workspace-sourced runtime.
 *
 * @param {RuntimeContext} runtimeContext
 * @param {object}         layoutSnapshot – { icons, theme, gridColumns, … }
 */
export const save = (runtimeContext, layoutSnapshot) => {
  if (runtimeContext?.runtimeMode !== RUNTIME_MODE.DRAFT_EDIT) {
    console.debug('[WorkspaceAdapter] save skipped – runtimeMode is not draft-edit', {
      runtimeMode: runtimeContext?.runtimeMode,
    });
    return;
  }
  scheduleDraftSave(runtimeContext, layoutSnapshot);
};
